import axios from "axios";
import { showLoading } from "./../../../module/loading";
import { hideLoading } from "./../../../module/loading";
/**
 * 見積を依頼する/見積依頼完了の初期化
 */
export function initSampleSeriesWeboothEstimate() {
    initEstimateButton();
}
/**
 * 見積を依頼するボタンの初期化
 */
function initEstimateButton() {
    const button = document.getElementById("sample-series-webooth-estimate-button");
    if (button === null)
        return;
    button.addEventListener("click", async () => {
        showLoading();
        const estimateTextarea = document.getElementById("sample-series-webooth-estimate-textarea");
        const message = estimateTextarea.value;
        const json = button.dataset.json;
        const data = JSON.parse(json);
        data.user_message = message;
        try {
            const response = await axios.post("/api/webooth-estimate", data);
            hideLoading();
            if (response.data.status !== undefined && !response.data.status) {
                window.alert("見積もりを依頼することができませんでした。");
                return;
            }
        }
        catch (error) {
            hideLoading();
            window.console.error(error);
            window.alert("見積もりを依頼することができませんでした。");
            return;
        }
        const completeTextarea = document.getElementById("sample-series-webooth-estimate-complete-textarea");
        completeTextarea.value = message;
        const estimateMain = document.getElementById("sample-series-webooth-estimate-main");
        const completeMain = document.getElementById("sample-series-webooth-estimate-complete-main");
        estimateMain.style.display = "none";
        completeMain.style.display = "block";
    });
}
